import { render, staticRenderFns } from "./jcgl.vue?vue&type=template&id=271b4e64&scoped=true"
import script from "./jcgl.vue?vue&type=script&lang=js"
export * from "./jcgl.vue?vue&type=script&lang=js"
import style0 from "./jcgl.vue?vue&type=style&index=0&id=271b4e64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b4e64",
  null
  
)

export default component.exports